<template>
	<div>
		<div class="section-gap primary pb-5">
			<v-container grid-list-xl pt-1>
				<v-layout row wrap align-center justify-center>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<h1 class="translate-right white--text">
								¡Todo lo que tu negocio necesita!
							</h1>
							<p class="translate-left white--text">
								Usa la tecnología para alcanzar los objetivos de tu negocio ¡No
								busques más!
							</p>
							<v-btn color="accent" to="/contactos" rounded>Comenzar ahora</v-btn>
						</div>
					</v-flex>
					<v-flex xs12 sm12 md6 lg6 xl6>
						<div class="subscribe-content">
							<div class="emb-aside-banner-v1 text-right">
								<img
									class="emb-card"
									alt="aside-banner"
									v-lazyload
									data-src="/static/images/functionalities.jpg"
									width="547"
									height="315"
								/>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
		<v-container mt-10>
			<v-row>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s1')">PUNTO DE VENTA</v-btn>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s2')">ADMINISTRACIÓN</v-btn>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s3')">INVENTARIO</v-btn>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s4')">PAGOS</v-btn>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s5')">REPORTES</v-btn>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="6" sm="12">
					<v-btn outlined block @click.prevent="scrollBy('#s6')">CONFIGURACIONES</v-btn>
				</v-col>
			</v-row>
		</v-container>
		<v-container id="s1">
			<v-row>
				<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
					<h2>Punto de venta</h2>
					<p>
						Sislii te permite realizar tus ventas de manera rápida y sencilla. Todo esto
						gracias a su diseño intuitivo.
					</p>
				</v-col>
				<v-col cols="12" xl="6" lg="6" md="6" sm="12">
					<img
						class="emb-card"
						alt="aside-banner"
						v-lazyload
						data-src="/static/images/functionalities.jpg"
						width="800"
						height="315"
					/>
				</v-col>
				<v-col cols="12" xl="6" lg="6" md="6" sm="12">
					<img
						class="emb-card"
						alt="aside-banner"
						v-lazyload
						data-src="/static/images/slider-2.jpg"
						width="800"
						height="315"
					/>
				</v-col>
			</v-row>
			<v-row class="text-center">
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Ventas al crédito</h6>
						<p>
							Con Sislii puedes realizar ventas al crédito, registrar el números
							cuotas y los plazos en que pagará el cliente.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Registro de clientes</h6>
						<p>
							Obtén los datos de Sunat, de manera que puedas emitir comprobantes de
							manera más rápida.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Búsqueda de productos</h6>
						<p>
							Busca productos por código de barras para agilizar ventas y mantener
							contento a tu clientela.
						</p>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="section-gap info lighten-5 pb-0">
			<v-container id="s2">
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
						<h3>Administración</h3>
						<p>
							Con Sislii mantienes tu información centralizada de manera que puedes
							tomar mejores decisiones para el crecimiento de tu negocio.
						</p>
						<img
							class="emb-card"
							alt="aside-banner"
							v-lazyload
							data-src="/static/images/slider-4.png"
							width="800"
							height="315"
						/>
					</v-col>
				</v-row>
				<v-row class="text-center">
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Roles y permisos</h6>
							<p>
								En Sislii nos tomamos muy en serio la seguridad de la información,
								por eso limita el acceso a tus colaborades creando roles y permisos
								de acuerdo a tu necesidad.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Ventas offline</h6>
							<p>
								Puedes continuar vendiendo incluso cuando no cuentes con Internet.
								Sislii sincronizará la información cuando la conexión vuelva.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Configuraciones</h6>
							<p>
								Adapta el sistema de acuerdo a tu necesidades, agrega modificadores,
								sube tu logotipo, crea tareas programadas, entre otras opciones.
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<v-container id="s3">
			<v-row>
				<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
					<h3>Inventario</h3>
					<p>
						El Sislii entedemos cuán importante es mantener un inventario actualizado,
						tener información sobre productos que están por agotarse, de esa manera
						tendrás un inventario abastecido.
					</p>
					<img
						class="emb-card"
						alt="aside-banner"
						v-lazyload
						data-src="/static/images/bg-2.jpg"
						width="800"
						height="315"
					/>
				</v-col>
			</v-row>
			<v-row class="text-center">
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Almacenes</h6>
						<p>
							Crea la cantidad de almacenes que necesitas asignalos a las sucursales,
							realiza traslados de un almacén a otro, ajustes de inventario.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Stock y Kardex</h6>
						<p>
							Con Sislii puedes tener un control exacto de tu inventario, hacer
							seguimiento a las operaciones que se hace con un producto mediante el
							kardex.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Precios</h6>
						<p>
							Puedes crear una o varias listas de precio asignarlo al producto crear
							diferentes presentaciones, manejar precios por sucursal, asignar precios
							por cada cliente.
						</p>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="section-gap accent lighten-5 pb-0">
			<v-container id="s4">
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
						<h3>Pagos</h3>
						<p>
							No limites a tus clientes a realizar el pago de una sola forma, deja que
							decidan ellos.
						</p>
						<img
							class="emb-card"
							alt="aside-banner"
							v-lazyload
							data-src="/static/images/bg-4.jpg"
							width="800"
							height="315"
						/>
					</v-col>
				</v-row>
				<v-row class="text-center">
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Métodos de pago</h6>
							<p>
								Deja a tus clientes elegir su forma de pago, Efectivo, Tarjeta
								débito o crédito o pago Mixto. Con el pago mixto pueden cancelar una
								parte de la cuenta con efectivo y la otra con su tarjeta VISA.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Emite comprobante relacionado</h6>
							<p>
								Al momento de realizar el cobro puedes elegir que comprobante desea
								el cliente, cambiar sus datos u obtener directamente de sunat.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Cuentas bancarias</h6>
							<p>
								Sislii permite tener todas las transacciones en tus cuentas
								bancarias actualizadas, cuando el cliente paga con tarjeta puede
								agregar una transacción en alguna cuenta específica.
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<v-container id="s5">
			<v-row>
				<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
					<h3>Reportes</h3>
					<p>
						En Sislii entedemos que lo más importante de un sistema son los reportes.
					</p>
					<img
						class="emb-card"
						alt="aside-banner"
						v-lazyload
						data-src="/static/images/slider-3.jpg"
						width="800"
						height="315"
					/>
				</v-col>
			</v-row>
			<v-row class="text-center">
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>ReporteS de Ventas</h6>
						<p>
							Mira desde cualquier dispositivo con conexión a internet y conoce tus
							ventas diarias, semanales o mensuales. Puedes realizar filtros por tipo
							de Pago o conocer al empleado con más ventas.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Estadísticas gráficas</h6>
						<p>
							Los reportes en forma de gráficas son mas fáciles de entender en Sislii
							encuentras los gráficos con las operaciones principales, como compras
							ventas flujo de caja, entre otros.
						</p>
					</div>
				</v-col>
				<v-col cols="12" xl="4" lg="4" md="6" sm="12">
					<div class="emb-card pa-4">
						<h6>Reportes de Caja</h6>
						<p>
							Sislii permite generar un reporte al final del día con un resumen de
							todos los mivimientos, cantidad de productos vendidos, y monto en
							transacciones.
						</p>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="section-gap info lighten-5 pb-0">
			<v-container id="s6">
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12" class="text-center">
						<h3>Configuraciones</h3>
						<p>
							El sistema de Sislii es totalmente configurable de manera que puedes
							adaptar el sistema de acuerdo a tus necesidades.
						</p>
						<img
							class="emb-card"
							alt="aside-banner"
							v-lazyload
							data-src="/static/images/bg-5.jpg"
							width="800"
							height="315"
						/>
					</v-col>
				</v-row>
				<v-row class="text-center">
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Tareas programadas</h6>
							<p>
								Hay cosas repetitivas en los procesos internos que tranquilamente
								podría hacerlo el sistema sin intervención del hombre, tales como
								aperturar o cerrar caja, enviar resúmenes de boletas a Sunat.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Registra sucursales</h6>
							<p>
								De tener sucursales creálos y meneja todas las operaciones de manera
								independiente por cada una de ellas, tales como flujo de caja, stock
								de productos, ventas, compras, entre otros.
							</p>
						</div>
					</v-col>
					<v-col cols="12" xl="4" lg="4" md="6" sm="12">
						<div class="emb-card pa-4">
							<h6>Ventas con cobro en caja</h6>
							<p>
								Hay negocios en las cuales hay una persona encargada de realizar los
								cobros, Sislii permite configurar si su flujo de trabajo es de esa
								manera.
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import lazyload from 'Directives/lazyload';
export default {
	data() {
		return {
			type: false,
		};
	},
	directives: {
		lazyload,
    },
    beforeCreate() {
		document.title = "Funcionalidades | Sislii";
    },
	methods: {
		scrollBy(hash) {
			document.querySelector(hash).scrollIntoView({
				block: 'start',
				behavior: 'smooth',
			});
		},
		detectOnline() {
			if (navigator.onLine) {
				alert('online');
			} else {
				alert('offline');
			}
		},
	},
};
</script>
